import { render, staticRenderFns } from "./ChallengeInsight.vue?vue&type=template&id=bb93fbac&scoped=true"
import script from "./ChallengeInsight.vue?vue&type=script&lang=js"
export * from "./ChallengeInsight.vue?vue&type=script&lang=js"
import style0 from "./ChallengeInsight.vue?vue&type=style&index=0&id=bb93fbac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb93fbac",
  null
  
)

export default component.exports